import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { getUserTypeLogoutPath, handleLogout, shouldSkipLogoutRedirectForPath } from 'utils/logout';

/**
 * Custom hook to log out and redirect to the correct login page
 * Usage: const logoutAndRedirect = useLogoutAndRedirect();
 *        await logoutAndRedirect();
 */
const useLogoutAndRedirect = () => {
  const userData = useSelector((state) => state.user?.data);
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(async () => {
    const logoutUrl = getUserTypeLogoutPath(userData?.type); // get before logout clears userData
    await handleLogout();
    if (!shouldSkipLogoutRedirectForPath(location.pathname)) {
      navigate(logoutUrl);
    }
  }, [userData, location.pathname, navigate]);
};

export default useLogoutAndRedirect;
